import {Address, IAddress} from "./address";
import {
  ILegalInformation,
  LegalEntityInformation,
  LegalInformation,
  NaturalPersonInformation
} from "./legal-information";
import {ITaxInformation, TaxInformation} from "./tax-information";
import {IShard, Shard} from "./shard";
import {LegalType} from "./legal-type";
import {CommunicationInformation, ICommunicationInformation} from "./communication-information";

export interface ICompany {
  id: string | undefined;
  name: string;
  alias: string;
  /**
   * Marks a company the demo tools may fill and remove (#916). The server accepts it only on create and refuses a
   * different value on update, so the wizard offers it while creating and shows it read-only afterwards.
   */
  isDemo: boolean;
  address: IAddress;
  legalInformation: ILegalInformation;
  taxInformation: ITaxInformation;
  communicationInformation: ICommunicationInformation;
  shards: IShard[];

  setLegalType(type: LegalType): void;
}

export class Company implements Company {
  id: string | undefined = undefined;
  name: string = '';
  alias: string = '';
  isDemo: boolean = false;
  address: IAddress = new Address();
  legalInformation: ILegalInformation = new LegalEntityInformation();
  taxInformation: ITaxInformation = new TaxInformation();
  communicationInformation: ICommunicationInformation = new CommunicationInformation();
  shards: IShard[] = [];

  static parse(obj: any): Company {
    const company = new Company();
    Object.assign(company, obj);
    company.address = Address.parse(obj.address);
    company.legalInformation = LegalInformation.parse(obj.legalInformation);
    company.taxInformation = TaxInformation.parse(obj.taxInformation);
    company.communicationInformation = CommunicationInformation.parse(obj.communicationInformation);
    company.shards = (obj.shards || []).map((shard: any) => Shard.parse(shard));
    return company;
  }

  setLegalType(type: LegalType): void {
    if (!confirm("Durch die Änderung des Rechtstyps werden alle rechtlichen Informationen gelöscht. Möchten Sie fortfahren?")) {
      return;
    }

    switch (type) {
      case LegalType.LegalEntity:
        this.legalInformation = new LegalEntityInformation();
        break;
      case LegalType.NaturalPerson:
        this.legalInformation = new NaturalPersonInformation(); // Assuming you have a NaturalPersonInformation class
        break;
      default:
        throw new Error(`Unsupported legal type: ${type}`);
    }
  }
}
